import { render, staticRenderFns } from "./ku_list.vue?vue&type=template&id=64dfcd67&"
import script from "./ku_list.vue?vue&type=script&lang=js&"
export * from "./ku_list.vue?vue&type=script&lang=js&"
import style0 from "./ku_list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports